import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { useParallaxRef } from '@/utils/parallax';

export default function NotificationsTab() {
  const subtitleRef = useParallaxRef({ speed: -0.10, axis: 'y', maxTranslate: 32 });

  return (
    <>
      <CardHeader className="text-center pb-12">
        <CardTitle className="text-4xl md:text-5xl font-bold mb-6">Services</CardTitle>
        <CardDescription ref={subtitleRef as any} className="text-xl md:text-2xl text-foreground/70 mb-20">
          The services you have purchased
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6 pt-4">
        <p className="text-muted-foreground text-center">
          <Link to="/contact" className="text-[#0000FF] hover:underline">
            Contact me
          </Link>
          {' '}to get free consulting and a custom website like this.
        </p>
      </CardContent>
    </>
  );
}

